var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Merge primitive and object arrays without duplicates
export var merge = function (a, b, predicate) {
    if (predicate === void 0) { predicate = function (c, d) { return c === d; }; }
    var c = __spreadArray([], a, true); // copy to avoid side effects
    b.forEach(function (bItem) {
        return c.some(function (cItem) { return predicate(bItem, cItem); }) ? null : c.push(bItem);
    });
    return c;
};
